import React, { use, useEffect, useRef, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { Box, Grid } from '@mui/material';
import { adobeData, theme } from "@/app/utils/Common";
import { Backdrop } from '@mui/material';
import Player, { PlayerProps } from "./player";
import ReplayIcon from "@/app/ui/Common/SvgComponent/ReplayIcon";
import { useMyContext } from "@/app/utils/MyContext";
import { LANGTYPE_EN, useLanguage } from "@/app/utils/LanguageContext";
import { textSize } from "@/app/utils/MixinSize";
import styled from "styled-components";
interface VideoPlayerProps extends PlayerProps {
  handleClose: ()=> void;
  trackImageSrc?: string;
  type?: string | undefined;
}

const TrackVideoRoot = styled.div<{ $isMobile: boolean }>`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: unset;
  z-index: 999;
  width: ${({ $isMobile }) => ($isMobile ? "calc(100% - 16px)" : "60%")};
`;


const VideoPlayer = (props: VideoPlayerProps) => {

  const [displayVideo, setdisplayVideo] = useState(false);
  const [displaySlot, setdisplaySlot] = useState(true);
  const {state: myContextState} = useMyContext();
  const {state: lang} = useLanguage();
  const { t } = lang;
  const renderonlyImage = () => {
    return <div className="videoContainer_trackContent"><img src={props?.trackImageSrc}></img></div>
  }
  const rendeimageWithVideo = () => {
    return <div className="videoContainer_trackContent">
        <img id={"trackAnalysisThumbnail"}src={props?.trackImageSrc}/>
          <p onClick={() => {
            setdisplaySlot(false)
            setdisplayVideo(true)
          }} style={{fontWeight: props.isMobile? 500 : 700}}>{t("Track_Video_text")} <ReplayIcon /></p>
      </div>
  }
  const handleClose = () => {
      setdisplayVideo(false);
     
      props?.handleClose();
      
      setTimeout(()=> {
        setdisplaySlot(true)
      }, 300)
  }
  return <Dialog
    open={props.open}
    onClose={handleClose}
    aria-labelledby="modal-title"
    aria-describedby="modal-description"
    className={`videoModal`}
    slots={{ backdrop: Backdrop }}
    slotProps={{
      backdrop: {
        style: {
          zIndex: 998,
        }
      }
    }}
  >
      {displaySlot ? <TrackVideoRoot $isMobile={props?.isMobile}><Grid className="title" item xs={12} sx={{
        height:"40px",
        backgroundColor: props.title ? theme.palette.primary.main : 'transparent',
        zIndex: 1,
        display: "flex",
        position: "relative",
        alignItems: 'center', 
        ...props.titleSx
      }}>
        {
          props.title && (<div id="modal-title" style={{
            maxHeight: '100%',
            fontWeight: 500,
            ...textSize(15),
            lineHeight: "28px",
            textAlign: 'center',
            marginTop: '6px',
            width: 'calc(100% - 30px)',
            display: '-webkit-box',
            '-webkit-line-clamp': '1',
            '-webkit-box-orient': 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: 'white',
          } as React.CSSProperties}>
            {props.title}
          </div>)
        }
        <Box className={`closeBtn`} onClick={(e) => handleClose()} style={{ top: 5}} >
          <img src={`${myContextState.assetPrefix}/close.svg`} />
        </Box>
      </Grid>
      <Grid item columns={12} id="video" className="videoContainer_track" sx={{
        background: displayVideo ? "#2f2f2f !important": "#fff",
        height:  displayVideo ? "calc( 100% - 40px )": "unset",
      }}> 

      { props?.type == 'onlyImage' ? renderonlyImage() : null }
      { props?.type == 'imageWithVideo' ? rendeimageWithVideo() : null }
      </Grid> </TrackVideoRoot>
      : null
      }
   
    {displayVideo && <Player {...props}  handleClose={handleClose}
      autoPlay={true}
      defaultPlayrate={1.5}/> }
  </Dialog>
}

export default VideoPlayer;